import React from 'react'
import PropTypes from 'prop-types'
import {Dropdown, FormControl} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {UserContext} from '../../../context/User'
import {AuditContext} from '../../../context/Audits'
import {ToastMessageContext} from '../../../context/ToastMessage'
const methodOptions = ['barcode_scan', 'manually_enter_id', 'prompt_each_time']

function UserEditBox({audit}) {
  const {t} = useTranslation()
  const toast = React.useContext(ToastMessageContext)
  const user = React.useContext(UserContext)
  const [loader, setLoader] = React.useState(false)
  const [showUserEditBoxState, setShowUserEditBoxState] = React.useState(false)
  const [commentErrorState, setCommentErrorState] = React.useState(false)
  const [userEditBoxState, setUserEditBoxState] = React.useState({
    method: audit.method,
    gps_location: audit.gps_location,
    asset_details: audit.asset_details,
    comments: '',
  })

  const {editAudit, selectAudit} = React.useContext(AuditContext)

  React.useEffect(() => {
    setUserEditBoxState({
      method: audit.method,
      gps_location: audit.gps_location,
      asset_details: audit.asset_details,
      comments: '',
      timezone: user.details.timezone,
    })
    setShowUserEditBoxState(false)
    setCommentErrorState(false)
  }, [audit, user.details.timezone])

  const tosterAlertPopup = response => {
    if (response !== null && response.status !== 500) {
      if (
        response.data.errors &&
        response.data.errors[0].base &&
        response.data.errors[0].base[0] !== undefined
      ) {
        toast.popMessage(response.data.errors[0].base[0], 'error')
      } else {
        toast.popMessage('Internal Server Error', 'error')
      }
    } else {
      toast.popMessage('Internal Server Error', 'error')
    }
  }

  const saveEditAuditMethodInfo = () => {
    if (userEditBoxState.comments === '') {
      setCommentErrorState(true)
    } else {
      try {
        setLoader(true)
        editAudit(audit.id, userEditBoxState).then(response => {
          if (response.id !== undefined) {
            toast.popMessage(`${response.name} is updated successfully`, 'success')
            setShowUserEditBoxState(false)
            selectAudit(response)
          } else {
            tosterAlertPopup(response)
          }
          setLoader(false)
        })
      } catch (e) {
        console.log(`Update Audit Method Failed`)
      }
    }
  }

  const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
    <button
      className="audit-dropdown__toggle audit-dropdown__toggle--detail"
      ref={ref}
      onClick={e => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {children}
    </button>
  ))

  const handleMethodCommentChange = e => {
    setUserEditBoxState({
      ...userEditBoxState,
      comments: e.target.value,
    })
    setCommentErrorState(false)
  }

  const editCheckboxes = disabled => (
    <div className="pl_0 width_100">
      <div className="ap-checkbox">
        <div className="ap-checkbox__control">
          <input
            id="edit_record_gps"
            type="checkbox"
            className={disabled ? 'ap-checkbox__input disabled_cursor' : 'ap-checkbox__input'}
            checked={userEditBoxState.gps_location}
            onChange={() =>
              setUserEditBoxState({
                ...userEditBoxState,
                gps_location: !userEditBoxState.gps_location,
              })
            }
            disabled={disabled}
          />
          <label for="edit_record_gps" className="ap-checkbox__label">
            {t('audit.detail-tab.labels.record-gps')}
          </label>
        </div>
        <div className="ap-checkbox__control">
          <input
            id="edit_show_asset"
            type="checkbox"
            className={disabled ? 'ap-checkbox__input disabled_cursor' : 'ap-checkbox__input'}
            checked={userEditBoxState.asset_details}
            onChange={() =>
              setUserEditBoxState({
                ...userEditBoxState,
                asset_details: !userEditBoxState.asset_details,
              })
            }
            disabled={disabled}
          />
          <label for="edit_show_asset" className="ap-checkbox__label">
            {t('audit.detail-tab.labels.show-asset')}
          </label>
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div className="row audit-detail-tab__edit-method">
        {showUserEditBoxState ? (
          <>
            <div className="row col-12">
              <div className="audit-detail-tab__label">AUDIT METHOD</div>
              <Dropdown className="audit-dropdown audit-dropdown--detail">
                <Dropdown.Toggle as={CustomToggle}>
                  <span className="audit-dropdown__toggle--underline">
                    {t(`audit.methods.${userEditBoxState.method}`)}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="audit-dropdown__menu"
                  popperConfig={{
                    placements: 'bottom-start',
                    modifiers: {
                      offset: {
                        offset: '-8px,-6px',
                      },
                      flip: {enabled: false},
                    },
                  }}
                >
                  {methodOptions.map(option => (
                    <Dropdown.Item
                      key={option}
                      className="audit-dropdown__item font_14"
                      onClick={() => setUserEditBoxState({...userEditBoxState, method: option})}
                    >
                      {t(`audit.methods.${option}`)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="mt_15 width_100">{editCheckboxes(null)}</div>
            <div className="mt_10 width_100">
              <div className="audit-detail-tab__label font_12">
                {t(`audit.detail-tab.labels.reason`)}
              </div>
              <FormControl
                as="textarea"
                aria-label={t(`audit.detail-tab.labels.reason`)}
                className="audit-detail-tab__text-area"
                onChange={e => handleMethodCommentChange(e)}
              />
              {commentErrorState && (
                <div className="audit-detail-tab__error">
                  {`*${t(`audit.detail-tab.labels.error`)}`}
                </div>
              )}
            </div>
            <div className="width_100 mt_8 text_right">
              <button
                className="audit-button audit-button--outline audit-button--black"
                onClick={() => setShowUserEditBoxState(false)}
              >
                {t('audit.detail-tab.labels.cancel')}
              </button>
              <button
                className="audit-button audit-button--blue ml_8"
                onClick={() => saveEditAuditMethodInfo()}
              >
                {loader ? t('audit.detail-tab.labels.saving') : t('audit.detail-tab.labels.save')}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex_row width_100">
              <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.methods')}</div>
              {audit.status !== 'completed' && audit.status !== 'incomplete' && (
                <button
                  className="audit-detail-tab__edit-button"
                  onClick={() => setShowUserEditBoxState(true)}
                >
                  {t('audit.detail-tab.labels.edit')}
                </button>
              )}
            </div>
            {audit.status !== 'completed' && audit.status !== 'incomplete' ? (
              <div className="audit-detail-tab__label audit-detail-tab__label--value">
                {t(`audit.methods.${audit.method}`)}
              </div>
            ) : (
              <div
                className="audit-detail-tab__label audit-detail-tab__label--value"
                style={{marginTop: 7}}
              >
                {t(`audit.methods.${audit.method}`)}
              </div>
            )}
            <div className="width_100 mt_5">{editCheckboxes(true)}</div>
          </>
        )}
      </div>
    </>
  )
}

UserEditBox.propTypes = {
  audit: PropTypes.shape({}).isRequired,
}

UserEditBox.displayName = 'UserEditBox'

export default UserEditBox
